// These are intentionally mutable exports. ES modules support "live
// bindings" for exports, so every file that imports { TODAY, DOY, YR }
// automatically sees the latest value after recomputeToday() reassigns
// them here — no need to re-import or pass them as props.

export let TODAY = new Date();
export let DOY = Math.ceil((TODAY - new Date(TODAY.getFullYear(), 0, 1)) / 86400000);
export let YR = TODAY.getFullYear();

export function recomputeToday() {
  TODAY = new Date();
  DOY = Math.ceil((TODAY - new Date(TODAY.getFullYear(), 0, 1)) / 86400000);
  YR = TODAY.getFullYear();
}

export function dayOfYearFromDate(d) {
  return Math.ceil((d - new Date(d.getFullYear(), 0, 1)) / 86400000);
}

export function daysInYear(y) {
  return (y % 4 === 0 && y % 100 !== 0) || y % 400 === 0 ? 366 : 365;
}
